import { memo } from "react";
import Button from "@mui/material/Button";
import { getBackofficePath } from "util/general";
import { BackOffice } from "consts/general";
import { PRE_APPLICATION_PATH } from "consts/onboarding";

const AddMerchantManually = () => (
    <Button
        variant='contained'
        data-test-id='onboarding.applications.controls.addMerchantManually'
        href={`//${getBackofficePath(BackOffice.Merchants, PRE_APPLICATION_PATH).toLowerCase()}`}
    >
        Add Merchant Application Manually
    </Button>
);

export default memo(AddMerchantManually);
